import { useInsiderState } from "@faire/retailer-visitor-shared/hooks/insider/useInsiderState";
import { useNationality } from "@faire/retailer-visitor-shared/hooks/retailer/useNationality";
import { useSettingInsiderMembershipPauseEnabled } from "@faire/retailer-visitor-shared/settings/useSettingInsiderMembershipPauseEnabled";
import { useSettingInsiderPhoneSuppportEnabled } from "@faire/retailer-visitor-shared/settings/useSettingInsiderPhoneSuppportEnabled";
export var useInsiderFeatureEligibility = function() {
    var _useNationality = useNationality(), isAmerican = _useNationality.isAmerican, isCanadian = _useNationality.isCanadian, isEurope = _useNationality.isEurope, isAustralian = _useNationality.isAustralian, isUK = _useNationality.isUK;
    var _useInsiderState = useInsiderState(), isInsiderPausedOrWillPause = _useInsiderState.isInsiderPausedOrWillPause, isInsiderTrial = _useInsiderState.isInsiderTrial, isInsiderUnpaid = _useInsiderState.isInsiderUnpaid;
    var isInsiderMembershipPauseEnabled = useSettingInsiderMembershipPauseEnabled();
    var isPhoneSupportEnabled = useSettingInsiderPhoneSuppportEnabled();
    var ignoreThresholdAdvertising = isCanadian || isAustralian;
    var hasFreeDutyAdvertising = isEurope;
    var hasPhoneSupport = isAmerican || isCanadian || isUK && isPhoneSupportEnabled;
    var hasReverseSeason = isAustralian;
    var hasProtectedEarlyAccessPerk = isAmerican || isCanadian || isAustralian;
    var hasSpecialTestimonial = isEurope;
    var hasSavingsBreakdown = isAmerican || isEurope;
    var hasNewPromoBanner = isCanadian || isAustralian;
    var hasMembershipTaxDisclaimer = isCanadian || isAustralian;
    var hasPauseMembershipFeature = (isAmerican || isCanadian || isAustralian) && isInsiderMembershipPauseEnabled;
    var canPauseMembership = hasPauseMembershipFeature && !(isInsiderPausedOrWillPause || isInsiderTrial || isInsiderUnpaid);
    var hasAccessToLoggedOutInsiderMarketingPage = isAmerican || isCanadian || isAustralian;
    return {
        hasFreeDutyAdvertising: hasFreeDutyAdvertising,
        hasPhoneSupport: hasPhoneSupport,
        hasProtectedEarlyAccessPerk: hasProtectedEarlyAccessPerk,
        hasSavingsBreakdown: hasSavingsBreakdown,
        hasSpecialTestimonial: hasSpecialTestimonial,
        hasReverseSeason: hasReverseSeason,
        ignoreThresholdAdvertising: ignoreThresholdAdvertising,
        hasNewPromoBanner: hasNewPromoBanner,
        hasMembershipTaxDisclaimer: hasMembershipTaxDisclaimer,
        hasPauseMembershipFeature: hasPauseMembershipFeature,
        canPauseMembership: canPauseMembership,
        hasAccessToLoggedOutInsiderMarketingPage: hasAccessToLoggedOutInsiderMarketingPage
    };
};
